module.exports = __webpack_public_path__ + "static/media/amazon_logo.8a0202e5.png";